import { formatFraction, formatValueByUnit } from '@/utils';

const DIVERGENCE_RATE_PER_RATE = 1;

// 乖離額の0/null対応用
export const formatDivergenceAmount = ({
  divergenceAmount,
  estimatedBusinessExpense,
  businessExpense,
  isDebugMode = false,
}: {
  divergenceAmount: number | null | undefined;
  /** 事業費見込み */
  estimatedBusinessExpense: number | null | undefined;
  /** 事業費 */
  businessExpense: number | null | undefined;
  isDebugMode: boolean;
}) => {
  // 乖離額 = 事業費見込み - 事業費
  const negativeCount = [
    estimatedBusinessExpense,
    typeof businessExpense === 'number' ? businessExpense * -1 : null,
  ].some((value) => value && value < 0);

  return formatValueByUnit(divergenceAmount, {
    operation: 'round',
    unit: 'thousand',
    showUnitLabel: false,
    negativeCount: negativeCount ? 1 : 0,
    isDebugMode,
  });
};

export const formatDivergenceRate = (
  divergenceRate: number | null | undefined,
) => {
  return formatFraction(divergenceRate, DIVERGENCE_RATE_PER_RATE, {
    maximumFractionDigits: 1,
    useNegativeSign: true,
  });
};
